<template>
<div class="container text-center" id="hudwindow" style="display:block;">
  <div class="jumbotron text-center overflow-auto">
    <h2>My HUDs</h2> <br> <br>
    <p style="font-size:22px;"><span style="color:aqua;">Current Fuel Cells:</span> {{user.credits}}</p>

    <table class="table table-dark text-center" style="margin:auto;">
    <thead>
     <tr>
      <td></td>
      <td> Tie Fighter </td>
      <td> Tiderian Shuttle</td>
      <td> Star Destroyer </td>
      <td> Death Star</td>
     </tr>
     </thead>
    <tbody>
     <tr>
      <td>Up to Nl50</td>

       <!-- Tie fighter -->
      <td> <div class="HUDbutton owned" id="TF" @click="hudWindow('TFX')"> Free </div></td>

       <!-- Tiderian Shuttle 50 -->
       <td v-if="user.credits>=5"><div class="HUDbutton owned" id="TS50" @click="hudWindow('TS50')">5 </div></td>
       <td v-else><div class="HUDbutton purchase" id="TS50" @click="hudWindow('TS50')"> 5 </div></td>

       <!-- Star Destroyer 50 -->
       <td v-if="user.credits>=10"><div class="HUDbutton owned" id="SD50" @click="hudWindow('SD50')">10 </div></td>
       <td v-else><div class="HUDbutton purchase" id="SD50" @click="hudWindow('SD50')"> 10 </div></td>

       <!-- Death Star 50 -->
       <td v-if="user.credits>=15"><div class="HUDbutton owned" id="DS50" @click="hudWindow('DS50')">15</div></td>
       <td v-else><div class="HUDbutton purchase" id="DS50" @click="hudWindow('DS50')"> 15</div></td>
      </tr>


         <tr>
       <td>Up to Nl200</td>
       <!-- Tie Fighter -->
       <td> <div class="HUDbutton owned" id="TF" @click="hudWindow('TFX')"> Free </div></td>

        <!-- Tiderian Shuttle 200 -->
         <td v-if="user.credits>=10"><div class="HUDbutton owned" id="TS200" @click="hudWindow('TS200')">10</div></td>
         <td v-else><div class="HUDbutton purchase" id="TS200" @click="hudWindow('TS200')"> 10</div></td>

        <!-- Star Destroyer 200 -->
       <td v-if="user.credits>=20"><div class="HUDbutton owned" id="SD200" @click="hudWindow('SD200')">20</div></td>
       <td v-else><div class="HUDbutton purchase" id="SD200" @click="hudWindow('SD200')">20</div></td>

        <!-- Death Star 200 -->
        <td v-if="user.credits>=30"><div class="HUDbutton owned" id="DS200" @click="hudWindow('DS200')">30</div></td>
         <td v-else><div class="HUDbutton purchase" id="DS200" @click="hudWindow('DS200')">30</div></td>
      </tr>





      <tr>

      <td>Unlimited</td>
      <!-- Tie Fighter -->
       <td> <div class="HUDbutton owned" id="TF" @click="hudWindow('TFX')"> Free </div></td>

        <!-- Tiderian Shuttle Unlimited -->
        <td v-if="user.credits>=15"><div class="HUDbutton owned" id="TSX" @click="hudWindow('TSX')">15</div></td>
        <td v-else><div class="HUDbutton purchase" id="TSX" @click="hudWindow('TSX')">15</div></td>

        <!-- Star Destroyer Unlimited -->
        <td v-if="user.credits>=30"><div class="HUDbutton owned" id="SDX" @click="hudWindow('SDX')">30</div></td>
        <td v-else><div class="HUDbutton purchase" id="SDX" @click="hudWindow('SDX')">30</div></td>

        <!-- Death Star Unlimited -->
         <td v-if="user.credits>=50"><div class="HUDbutton owned" id="DSX" @click="hudWindow('DSX')">50</div></td>
         <td v-else><div class="HUDbutton purchase" id="DSX" @click="hudWindow('DSX')">50</div></td>
        </tr>


        <br>
        </tbody>
    </table>


    <br>
    <div v-if="hudData" class="container w-50" id="HUDdata" style="background-color:#161b1d; position:relative; overflow:hidden; border-radius:30px;">
      <div v-if="hudWindowOpacity < 1"  style="position:absolute; top: 40%; left: 40%; z-index: 1000; opacity: 1;">
          <div class="spinner-border text-secondary" role="status">
               <span class="sr-only" style="color:white;">Loading...</span>
            </div>
            <p style="color:white;"> Loading... </p>
         </div>
       <div :style="{opacity : hudWindowOpacity}" class="pt-3">  
      <p class="cyan d-inline"> Selected HUD: </p> <p class="d-inline" id="selection">{{hud.name}}</p><br>
       <img :src="hud.image" style="height:88px;" class="d-block mx-auto m-3" alt="TS">
      <p class="cyan d-inline"> Available:</p> <p class="d-inline"> {{ hud.owned }} </p><br>
      <button class="btn btn-outline-info btn-sm m-3" @click="request_activation(hud.ref)" v-if="hud.activated == 0 & hud.owned == true"> Activate </button>
      <button class="btn btn-outline-info btn-sm m-3"  v-else-if="hud.activated == 0 & hud.owned == false"> Purchase </button>
      <div v-else-if="hud.activated == 2 & hud.owned == true"><p class="green"> Pending Activation </p></div>
      <div v-else>
      <p class="big green">HUD Activated</p>
      <button class="btn btn-info mb-5">
        <a :href="'download/' + hud.ref">Download HUD Files</a>
        </button>
      </div>
    </div>
    </div>
    <br> <br>
<p class="text-left">
  HUDs in <span class="owned">green</span> are ready to launch while HUDs in <span class="purchase">red</span>
  don't have the required full cells. Click on a HUD to get more information and/or request activation.
    </p>


  </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('Huds component mounted');
    this.refresh();
  },

  data() {
    return {
      hud : {},
      hudData : false,
      hudWindowOpacity : 1
    }
  },

  props : {
    'user' : Object
  },

  methods: {

      hudWindow(hudRef) {
                  //this.hudData = false;
                  this.hudWindowOpacity = 0.2;
                  this.axios.get('/get/huddata/' + hudRef).then((response) => {
                  this.hud = response.data;
                  this.selectedHUD = hudRef;
                  this.hudData = true;
                  this.hudWindowOpacity = 1;
                  let hudVersion = "_1.4";
                 this.selectedDownload = "files/" + hudRef + hudVersion + ".exe";
         });
        },

        request_activation(hudRef) {
          this.axios.get('/request/activation/' + hudRef).then((response) => {
             var modal = {
                  message : 'Activation request submitted. We have emailed you the details. Keep in mind that this request could take up to 24 hours',
                  title : 'Submitted'
                }
                this.$emit('show-modal-event', modal);
                this.hud.activated = 2;
          });
        },


        refresh() {
          console.log('refresh function');
        }
  }
}
</script>

<style>

</style>
